import { useContext } from "react";
import { ProductsContext } from "../contexts/ProductsContext";

export function useProduct() {
    const value = useContext(ProductsContext);
    return value;
}